






import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    watch,
    Ref,
    ref,
} from '@vue/composition-api';
import { MultiSelectOptionType } from '../type';

export default defineComponent({
    props: {
        option: {
            type: Object as PropType<MultiSelectOptionType>,
            default: () => {},
        },
    },
    setup(props, context) {},
});
